import { createFileRoute } from '@tanstack/react-router'
import { MarketingShell } from '@/components/admin/marketing/MarketingShell'
import { AdminPosterStudio } from '@/components/admin/marketing/AdminPosterStudio'
import type { PosterPurpose } from '@/types'

// /admin/marketing/posters — the Poster Studio. ?purpose=<id> deep-link
// lands on a specific QR purpose (loyalty | menu | reviews | …); the
// studio defaults to "loyalty" when no value is provided.
type PosterSearch = { purpose?: PosterPurpose }

export const Route = createFileRoute('/admin/marketing/posters')({
  validateSearch: (s: Record<string, unknown>): PosterSearch => {
    const allowed = ['loyalty', 'menu', 'reviews', 'instagram', 'website', 'custom']
    const purpose = typeof s.purpose === 'string' && allowed.includes(s.purpose)
      ? (s.purpose as PosterPurpose)
      : undefined
    return purpose ? { purpose } : {}
  },
  component: () => (
    <MarketingShell
      title="Poster Studio"
      description="Print-ready posters for every QR you publish — loyalty, menus, reviews, social, websites, and one-offs. Pick a theme, tweak the copy, and download a PDF or PNG."
    >
      <AdminPosterStudio />
    </MarketingShell>
  ),
})
